<template>
  <div class="search">
    <n-input
      v-model:value="searchValue"
      class="search-input"
      :class="{ isActive: isActive }"
      type="text"
      placeholder="Global Search"
      @keyup.enter="searchHanlder"
    >
      <template #prefix>
        <svg-icon class="contact_icon" icon-name="search_icon" icon-class="search_icon" />
      </template>
    </n-input>
    <div class="search-icon" :class="{ isActive: !isActive }">
      <svg-icon icon-name="search" icon-class="search" @click="toggle(true)" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';

const porps = defineProps({
  isActive: {
    type: Boolean,
    default: false,
  },
});
const router = useRouter();
const emit = defineEmits(['toggle']);

const searchValue = ref('');
const searchHanlder = () => {
  router.push({
    name: '/searchPage',
    query: {
      searchValue: searchValue.value,
    },
  });
  toggle(false);
};
const toggle = (flag: boolean) => {
  emit('toggle', flag);
};
watch(
  () => porps.isActive,
  (val) => {
    if (!val) {
      searchValue.value = '';
    }
  }
);
</script>

<style lang="scss" scoped>
.search {
  font-size: 20px;
  margin-right: 30px;
  margin-bottom: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 100px;
  svg {
    cursor: pointer;
  }
}

.search-icon {
  opacity: 0;
  &.isActive {
    transition-delay: 0.8s;
    opacity: 1;
  }
}

.search-input {
  background: #f9f8fe;
  width: 0px !important;
  transition: all 0.8s;
  border: none;
  opacity: 0;

  &.isActive {
    width: 320px !important;
    opacity: 1;
  }
  .n-input__border {
    border: none;
  }
}
</style>
